import { SmsCreditPackages } from "sharedTypes"
import React, { useState } from "react"
import BuyTextMessageCreditsModal
  from "modals/TextMessage/TextMessageCredits/BuyTextMessageCreditsModal"

type Props = {
  eventId: string
  smsCreditPackages: SmsCreditPackages
  onHide: () => void
}

const BuyTextMessageCredits = ({
  eventId,
  smsCreditPackages,
  onHide,
}: Props) => {
  const amountOptions = Object.entries(smsCreditPackages).map(([key, value]) => ({
    amount: key, label: `${value} Credits`,
  }))

  const [selectedCreditPackageAmount, setSelectedCreditPackageAmount] = useState(
    amountOptions[0].amount,
  )

  return (
    <BuyTextMessageCreditsModal
      eventId={eventId}
      onHide={onHide}
      amountOptions={amountOptions}
      selectedCreditPackageAmount={selectedCreditPackageAmount}
      setSelectedCreditPackageAmount={setSelectedCreditPackageAmount}
    />
  )
}

export default BuyTextMessageCredits
